var actions = {
	next: "Suivant",
	confirm: "Confirmer",
	"continue": "Continuer"
};
var errors = {
	unknown: "Une erreur inconnue est survenue",
	contactSupport: "Une erreur est survenue. Merci de contacter l'assistance.",
	tryAgain: "Une erreur est survenue. Réessaie.",
	submit: "Il y a eu une erreur dans ton envoi."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Connecte-toi avec {name}",
	signupWith: "Inscris-toi avec {name}"
};
var alreadyHaveAccount = {
	company: "Tu as déjà un compte {company}?",
	text: "Tu as déjà un Streamlabs ID?",
	link: "Se connecter"
};
var noAccount = {
	text: "Tu n'as pas encore de compte?",
	link: "S'inscrire"
};
var validation = {
	email: {
		invalid: "Saisis une adresse e-mail valide"
	},
	password: {
		required: "Un mot de passe est nécessaire",
		min: "Le mot de passe doit contenir plus de 8 caractères",
		number: "Le mot de passe doit contenir un chiffre",
		upper: "Le mot de passe doit contenir une majuscule",
		special: "Le mot de passe doit contenir un caractère spécial"
	},
	username: {
		invalid: "Le nom doit contenir au moins 5 caractères"
	},
	code: {
		minmax: "Le code doit contenir entre 6 et 10 caractères"
	}
};
var poweredBy = "Alimenté par <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Société introuvable!",
		desc: "Essaie à nouveau plus tard ou contacte l'assistance."
	},
	company: {
		logoAlt: "Logo {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Code d'authentification à 6 chiffres/code de récupération à 8 chiffres",
	successText: "Tout est bon! Redirection...",
	remember: "Se souvenir de ce dispositif pendant 30 jours"
};
var createTfa = {
	scan: {
		title: "Activer l'authentification à deux facteurs",
		lead: "Clique/copie ou scanne le code ci-dessous en utilisant ton application d'authentification préférée. Nous te recommandons d'utiliser une application comme <app0 />, <app1 /> ou <app2 /> pour stocker tes codes en toute sécurité.",
		copied: "Copie effectuée!",
		instructions: "Ou saisis manuellement ce code dans ton application d'authentification.",
		copy: "Copier le code",
		proceed: "Confirmation"
	},
	confirm: {
		title: "Confirme ton authentification à 2 facteurs",
		lead: "Soumets un code 2FA généré ci-dessous pour confirmer et activer l'authentification à 2 facteurs.",
		label: "Code d'authentification à 2 facteurs (6 caractères)",
		verify: "Vérifier le code",
		next: "Tout est bon! Étape suivante"
	},
	save: {
		title: "Sauvegarde tes codes de récupération",
		lead: "Sauvegarde tes codes de récupération ci-dessous en cas de perte d'accès à ton application d’authentification à 2 facteurs. Une fois que tu auras fermé cette fenêtre, ces codes ne seront plus disponibles.",
		label: "Codes de récupération",
		download: "Télécharger les codes de récupération",
		copied: "Codes copiés!",
		finished: "Terminé"
	}
};
var emailLoginForm = {
	buttonText: "Se connecter",
	emailPlaceholder: "E-mail",
	passwordPlaceholder: "Mot de passe"
};
var emailSignupForm = {
	buttonText: "S'inscrire",
	emailPlaceholder: "Définir une adresse e-mail",
	passwordPlaceholder: "Définir un mot de passe",
	usernamePlaceholder: "Ton nom",
	ageLabel: "Date de naissance",
	agePlaceholder: "JJ/MM/AAAA",
	agreeText: "J'accepte les <terms>conditions d'utilisation</terms> et la <privacy>politique de confidentialité</privacy> de Streamlabs.",
	agreeError: "Merci d'accepter les conditions générales de Streamlabs"
};
var ageInput = {
	invalidDate: "Saisis une date d'anniversaire valide",
	futureDate: "La date de naissance doit être passée",
	minDate: "Les dates antérieures à l'année {year} ne sont pas autorisées",
	minAge_one: "Tu dois avoir {years} an ou plus pour pouvoir utiliser Streamlabs.",
	minAge_two: "Tu dois avoir {years} ans ou plus pour pouvoir utiliser Streamlabs.",
	minAge_other: "Tu dois avoir {years} ans ou plus pour pouvoir utiliser Streamlabs."
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mail",
	back: "Revenir à la page de connexion",
	successText: "Tout est bon! Nous t'avons envoyé un code de réinitialisation du mot de passe.",
	buttonText: "Demander un e-mail de réinitialisation",
	create: {
		successText: "Tout est bon! Nous t'avons envoyé un code de vérification pour t'aider à démarrer!",
		buttonText: "Demander un code de vérification"
	},
	errors: {
		notFound: "Aucun compte ne correspond à cette adresse e-mail"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Tu as oublié ton mot de passe?",
	lead: "Si tu as besoin de réinitialiser ton mot de passe, saisis ton e-mail ci-dessous et nous t'enverrons un e-mail pour démarrer le processus.",
	resetTitle: "Réinitialiser le mot de passe",
	resetLead: "Tu devrais avoir reçu un code par e-mail. Complète le formulaire pour réinitialiser ton mot de passe.",
	create: {
		title: "Crée ton mot de passe",
		lead: "Félicitations, tu as créé ton Streamlabs ID! Une étape de plus et tu pourras te connecter à toutes les produits Streamlabs!",
		resetTitle: "Choisis un mot de passe",
		resetLead: "Tu devrais avoir reçu un code par e-mail. Utilise-le et complète le formulaire pour définir ton mot de passe."
	},
	successText: "Tout est bon! Redirection...",
	signInTitle: "Tu as déjà un compte?",
	signInBtn: "Se connecter"
};
var checkTfaCard = {
	title: "Vérification de l’authentification à 2 facteurs",
	lead: "Saisis un code d'authentification à 2 facteurs ci-dessous pour continuer.",
	successText: "Confirmation du code 2FA réussie!",
	back: "Retour"
};
var verifyEmailCard = {
	title: "Vérifie ton e-mail",
	lead: "Vérifie si tu as reçu un code à 8 caractères de Streamlabs par e-mail et saisis-le ci-dessous.",
	back: "Retour",
	successText: "L'e-mail a été vérifié avec succès!"
};
var upgradeCard = {
	confirm: {
		title: "Confirme la connexion à {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Dorénavant, tu pourras te connecter à {company} avec l'e-mail et le mot de passe fournis.",
			"Tu peux accéder à d'autres produits de Streamlabs avec ton ID et te connecter à d'autres comptes si tu en as.",
			"Ton compte {company} ne sera pas impacté par ce changement."
		],
		button: "Confirmer",
		cancel: "Annuler",
		switchAccount: "Changer de compte",
		success: "Connexion en cours..."
	},
	confirmed: {
		title: "Tout est bon!",
		subtitle: "Ton Streamlabs ID a été créé et ton compte {company} est connecté.",
		text: "Tu peux utiliser ton Streamlabs ID pour tous les produits Streamlabs. Si tu as déjà d'autres comptes, tu peux les connectez à cet ID à partir de chaque application.",
		button: "Fermer"
	},
	error: {
		user: "L'identification de l'utilisateur a échoué. Essaie de te reconnecter ou contacte l'assistance."
	}
};
var confirmCard = {
	confirm: {
		title: "Confirme la connexion à {company}",
		subtitle: "Nous avons trouvé un compte avec une adresse e-mail correspondante. Veux-tu fusionner ce compte avec Streamlabs ID ?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Tu pourras te connecter à {company} avec l'adresse e-mail et le mot de passe associés à ton Streamlabs ID.",
			"Tu peux accéder à d'autres produits de Streamlabs avec ton ID et te connecter à d'autres comptes si tu en as.",
			"Le compte de ton entreprise ne sera pas impacté par ce changement."
		],
		button: "Confirmer",
		cancel: "Annuler",
		switchAccount: "Changer de compte",
		success: "Connexion en cours..."
	},
	confirmed: {
		title: "Tout est bon!",
		subtitle: "Ton Streamlabs ID a été créé et ton compte {company} est connecté.",
		text: "Tu peux utiliser ton Streamlabs ID pour tous les produits Streamlabs. Si tu as déjà d'autres comptes, tu peux les connectez à cet ID à partir de chaque application.",
		button: "Fermer"
	},
	error: {
		user: "L'identification de l'utilisateur a échoué. Essaie de te reconnecter ou contacte l'assistance."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Ton ID est déjà associé à un compte {company}.",
		subtitle: "Veux-tu dissocier le compte connecté et le lier à ton compte Streamlabs actuel?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Tu pourras te connecter à Streamlabs avec l'adresse e-mail et le mot de passe associés à ton Streamlabs ID.",
			"Tu peux accéder à d'autres produits de Streamlabs avec ton ID et te connecter à d'autres comptes si tu en as.",
			"Ton compte Streamlabs ne sera pas impacté par ce changement."
		],
		button: "Confirmer",
		cancel: "Annuler",
		switchAccount: "Changer de compte",
		success: "Connexion en cours...",
		agreeLabel: "Je comprends qu'en effectuant cette connexion, je perdrai l'accès au compte {company} existant associé au Streamlabs ID."
	},
	confirmed: {
		title: "Tout est bon!",
		subtitle: "Ton Streamlabs ID a été créé et ton compte {company} est connecté.",
		text: "Tu peux utiliser ton Streamlabs ID pour tous les produits Streamlabs. Si tu as déjà d'autres comptes, tu peux les connectez à cet ID à partir de chaque application.",
		button: "Fermer"
	},
	error: {
		user: "L'identification de l'utilisateur a échoué. Essaie de te reconnecter ou contacte l'assistance."
	}
};
var loginCard = {
	title: "Se connecter",
	lead: "Connecte-toi à <company>{company}</company> avec ton <id>Streamlabs ID</id>",
	accountExists: "Il semblerait que tu aies un <b>Streamlabs ID</b>. Essaie de te connecter avec ton e-mail.",
	forgotPassword: "Mot de passe oublié?",
	successText: "Tout est bon! Redirection...",
	signInTitle: "Connecte-toi avec une plateforme"
};
var loginSourcesCard = {
	title: "Se connecter",
	lead: "Se connecter avec un e-mail/mot de passe",
	withSlId: "Se connecter avec un Streamlabs ID",
	noAccountMessage: "Nous n'avons trouvé aucun compte associé à ce mode de connexion. Essaie un autre mode de connexion ou <signup>inscris-toi</signup> si tu ne l'as pas encore fait.",
	accountExistsMessage: "Ton adresse e-mail Twitch est déjà associée à un compte Streamlabs. Essaie de te connecter avec ton e-mail et ton mot de passe Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mail",
	codePlaceholder: "Code e-mail à 6-8 caractères",
	tfaCodePlaceholder: "Code 2FA",
	newPasswordPlaceholder: "Nouveau mot de passe",
	tfaError: "Le code de réinitialisation doit contenir entre 6 et 10 caractères",
	next: "Tu as reçu le code?",
	back: "Retour à Mot de passe oublié",
	buttonText: "Modifier le mot de passe",
	successText: "Réinitialisation du mot de passe réussie",
	create: {
		back: "Retour au début",
		buttonText: "Définir le mot de passe",
		successText: "Mot de passe défini avec succès"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Mot de passe actuel",
	newPasswordPlaceholder: "Nouveau mot de passe",
	newPasswordConfirmationPlaceholder: "Confirmer le nouveau mot de passe",
	buttonText: "Modifier le mot de passe",
	successText: "Actualisation du mot de passe réussie",
	newPasswordConfirmationError: "Les nouveaux mots de passe ne correspondent pas",
	back: "Revenir au tableau de bord"
};
var changePasswordCard = {
	title: "Modifier ton mot de passe",
	lead: "Saisis ton mot de passe actuel et un nouveau mot de passe ci-dessous.",
	successText: "Actualisation du mot de passe réussie"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Code d'authentification à 6 chiffres/code de récupération à 8 chiffres",
	successText: "Code 2FA supprimé avec succès",
	removeBtn: "Confirmer et supprimer"
};
var removeTfaCard = {
	title: "Supprimer l’authentification à 2 facteurs",
	lead: "Saisis un code de confirmation 2FA ci-dessous pour supprimer l'authentification à 2 facteurs de ton compte.",
	successText: "Code 2FA supprimé avec succès",
	back: "Revenir au tableau de bord"
};
var verifyEmailForm = {
	codePlaceholder: "Code à 8 caractères depuis l'e-mail",
	tfaCodePlaceholder: "Code 2FA",
	emailPlaceholder: "Adresse e-mail",
	buttonText: "Vérifier l'e-mail",
	successText: "Vérification de l'e-mail réussie",
	requestBtn: "Demander un nouveau code",
	requestingBtn: "Demande envoyée...",
	requestSuccess: "Un code a été envoyé à ton adresse e-mail",
	requestAgain: "Demande à nouveau dans {seconds}s",
	tfaError: "Le code de réinitialisation doit contenir entre 6 et 10 caractères",
	back: "Retour"
};
var signupCard = {
	title: "S'inscrire",
	lead: "Crée un <id>Streamlabs ID</id> pour utiliser <company>{company}</company>",
	successText: "Tout est bon! Redirection..."
};
var signupSourcesCard = {
	title: "S'inscrire",
	lead: "Crée un <id>Streamlabs ID</id> pour utiliser <company>{company}</company>",
	withSlId: "Créer un Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Choisis un compte",
		lead: "pour continuer sur <b>{company}</b>",
		authorize: "Autoriser",
		authorizeSuccess: "Tout est bon!",
		cancel: "Annuler",
		disclaimer: {
			streamlabs: "En continuant, tu partageras ton Streamlabs ID (nom, adresse e-mail, préférence linguistique et photo de profil) avec <b>{company}</b>. En autorisant un compte avec <b>{company}</b>, tu acceptes par la présente la <privacy>politique de confidentialité</privacy> et les <terms>conditions d'utilisation</terms> de <b>{company}</b>.",
			"default": "Pour continuer, Streamlabs partagera ton nom, ton adresse e-mail, ta préférence linguistique et ta photo de profil avec <b>{company}</b>. En autorisant un compte avec <b>{company}</b>, tu acceptes par la présente la <privacy>politique de confidentialité</privacy> et les <terms>conditions d'utilisation</terms> de <b>{company}</b>."
		},
		emailRequired: "Vérification de l'e-mail requise avant de procéder",
		tfaRequired: "L'authentification à 2 facteurs est requise avant de procéder."
	},
	login: {
		title: "Connecte-toi à {company}",
		lead: "Tu dois être connecté pour connecter les comptes",
		loginBtn: "Procéder à la connexion"
	},
	error: {
		title: "Connecte-toi à {company}",
		lead: "Ta demande n'a pas pu être autorisée pour le moment.",
		verifyEmail: "Vérifier l'e-mail",
		verify2fa: "Vérifier le code 2FA"
	},
	"switch": {
		btn: "Utilise un autre compte."
	}
};
var appsDropdown = {
	label: "Produits et applications Streamlabs",
	viewMore: "Développer",
	viewLess: "Réduire"
};
var platformButtons = {
	loginWithPlatform: "Connecte-toi avec une plateforme",
	signUpWithPlatform: "S’inscrire via une plateforme",
	signUpLead: "Nous prenons en charge le streaming en direct sur de nombreuses autres plateformes, il s’agit juste d’options d’inscription."
};
var ultraCheckoutCard = {
	title: "Améliore tes streams en direct, ton image de marque, ton montage et bien plus encore avec <b>Streamlabs Ultra</b>",
	badge: "Cela comprend <b>{planName}</b>",
	totalValue: "Valeur de {price, currency}",
	price: {
		month: "{price, currency}/mois",
		year: "{price, currency}/an"
	},
	description: {
		month: "Accède aux fonctions premium de toute la suite, y compris <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, et bien d'autres encore, à un prix unique et abordable.",
		year: "Accède aux fonctions premium de toute la suite, y compris <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, et bien d'autres encore, à un prix unique et abordable."
	},
	seeIncluded: "En savoir plus",
	buyNow: "Mise à niveau"
};
var ultraCheckoutBanner = {
	title: "Améliore tes streams en direct, ton image de marque, ton montage et bien plus encore avec <b>Streamlabs Ultra</b>",
	badge: "Cela comprend <b>{planName}</b>",
	totalValue: "Valeur de {price, currency}",
	price: {
		month: "{price, currency}/mois",
		year: "{price, currency}/an"
	},
	description: {
		month: "Accède aux fonctions premium de toute la suite, y compris <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, et bien d'autres encore, à un prix unique et abordable. <link />",
		year: "Accède aux fonctions premium de toute la suite, y compris <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, et bien d'autres encore, à un prix unique et abordable. <link />"
	},
	seeIncluded: "En savoir plus",
	buyNow: "Mise à niveau"
};
var connect = {
	waitMessage: "Fusion de données. Merci de ne pas fermer cette fenêtre."
};
var verifyPasswordCard = {
	success: "Vérification du mot de passe réussie",
	title: "Ré-authentifie-toi pour procéder à la vérification",
	lead: "Connecte-toi avec ton e-mail et ton mot de passe existants pour continuer à mettre à jour ton Streamlabs ID.",
	buttonText: "Suivant"
};
var emailChangeForm = {
	agreeError: "Vérifie que tu as bien compris cette action",
	buttonText: "Suivant",
	emailPlaceholder: "Nouvelle adresse e-mail",
	agreeText: "Je comprends qu'une fois vérifié, mon Streamlabs ID changera sur tous les produits Streamlabs auxquels il est connecté."
};
var verifyNewEmailCard = {
	title: "Change ton Streamlabs ID",
	lead: "Fournis une nouvelle adresse e-mail que tu utiliseras comme Streamlabs ID. Nous enverrons un code de vérification de 6 à 8 chiffres à cette adresse.",
	successText: "Nouvel e-mail disponible"
};
var verifyNewEmailOwnershipCard = {
	title: "Vérifie ton Streamlabs ID mis à jour",
	lead: "Vérifie si tu as reçu un code à 8 caractères de Streamlabs par e-mail et saisis-le ci-dessous.",
	buttonText: "Confirmer",
	back: "Retour",
	codePlaceholder: "Code à 8 caractères depuis l'e-mail",
	successText: "La propriété de l'e-mail a été vérifiée avec succès"
};
var verifyTfaCard = {
	title: "Code d'authentification à 2 facteurs",
	lead: "Saisis le code de vérification à 6 chiffres de ton appli d'authentification.",
	codePlaceholder: "Code à 6 chiffres",
	buttonText: "Confirmer",
	successText: "Authentification à 2 facteurs confirmée",
	back: "Retour"
};
var ageGateForm = {
	ageLabel: "Date de naissance",
	agePlaceholder: "JJ/MM/AAAA"
};
var ageGateCard = {
	title: "Configuration complète du compte",
	lead: {
		years: "Tu dois avoir {years} ans ou plus pour pouvoir créer un compte. <br />Saisis ta date de naissance pour finaliser la configuration.",
		noYears: "Tu dois fournir ta date de naissance pour pouvoir créer un compte. <br />Saisis-la pour finaliser la configuration."
	},
	successText: "Félicitations! La configuration du compte est terminée."
};
var frFR = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { frFR as f };
//# sourceMappingURL=fr-FR.es.js.map
